import { render, staticRenderFns } from "./MessagesReceived.vue?vue&type=template&id=493a829c&scoped=true&"
import script from "./MessagesReceived.vue?vue&type=script&lang=js&"
export * from "./MessagesReceived.vue?vue&type=script&lang=js&"
import style0 from "./MessagesReceived.vue?vue&type=style&index=0&id=493a829c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493a829c",
  null
  
)

export default component.exports